'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaddingBox = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PaddingBoxStyled = require('./styles/PaddingBoxStyled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  /** Set padding size*/
  paddingSize: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['small', 'medium', 'large']), _propTypes2.default.string]),
  /**
   * Remove corresponding paddings
   */
  removePadding: _propTypes2.default.oneOf(['none', 'horizontal', 'vertical']),
  /** Container will occupy all available space */
  spread: _propTypes2.default.bool
};

var defaultProps = {
  paddingSize: 'small',
  removePadding: 'none',
  spread: false
};

var PaddingBox = exports.PaddingBox = function PaddingBox(props) {
  return _react2.default.createElement(
    _PaddingBoxStyled.PaddingBoxStyled,
    {
      paddingSize: props.paddingSize,
      removePadding: props.removePadding,
      spread: props.spread
    },
    props.children
  );
};

PaddingBox.propTypes = propTypes;
PaddingBox.defaultProps = defaultProps;
PaddingBox.displayName = 'PaddingBox';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-grid/dist/PaddingBox/PaddingBox.js
// module id = 689
// module chunks = 0